import { Button, Stack } from "@mui/material";
import React from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa6";
import { LuLayoutGrid } from "react-icons/lu";

const BlogSliderSection = () => {
  return (
    <Stack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // border: "1px solid red",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid #ddd",
            marginTop: "40px",
            width: {
              xl: "100%",
              lg: "100%",
              md: "100%",
              sm: "100%",
              xs: "100%",
            },
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            // border: "1px solid red",
          }}
        >
          {/* first section */}
          <Stack
            sx={{
              width: { xl: "45%", lg: "45%", md: "45%", sm: "45%", xs: "45%" },
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              //   border: "2px solid blue",
            }}
          >
            <Stack
              sx={{
                width: {
                  xl: "10%",
                  lg: "10%",
                  md: "10%",
                  sm: "10%",
                  xs: "10%",
                },
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              <Stack
                sx={{
                  height: { xl: "40px" },
                  width: { xl: "40px" },
                  borderRadius: "50%",
                  backgroundColor: "#365493",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaLessThan size={20} style={{ color: "#FFFFFF" }} />
              </Stack>
            </Stack>{" "}
            <Stack
              sx={{
                width: {
                  xl: "90%",
                  lg: "90%",
                  md: "90%",
                  sm: "90%",
                  xs: "90%",
                },
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                // border: "2px solid green",
              }}
            >
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Stack
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: {
                      xl: "flex-start",
                      lg: "flex-start",
                      md: "flex-start",
                      sm: "flex-start",
                      xs: "center",
                    },
                    marginBottom: "16px",
                  }}
                >
                  Newer
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    display: {
                      xl: "flex",
                      lg: "flex",
                      md: "flex",
                      sm: "flex",
                      xs: "none",
                    },
                    marginBottom: "16px",
                  }}
                >
                  Discription
                </Stack>
                <Stack
                  sx={{
                    width: { xl: "50%", lg: "50%", md: "50%", sm: "50%" },
                    display: {
                      xl: "flex",
                      lg: "flex",
                      md: "flex",
                      sm: "flex",
                      xs: "none",
                    },
                  }}
                >
                  <Button variant="contained">Reading Time Button</Button>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          {/* second section */}
          <Stack
            sx={{
              width: { xl: "10%", lg: "10%", md: "10%", sm: "10%" },
              // border: "1px solid red",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack>
              <LuLayoutGrid size={20} style={{ color: "grey" }} />
            </Stack>
          </Stack>
          {/* third section */}
          <Stack
            sx={{
              width: { xl: "45%", lg: "45%", md: "45%", sm: "45%", xs: "45%" },
              display: "flex",
              flexDirection: "row",
              // justifyContent: "space-between",
              //   border: "2px solid blue",
            }}
          >
            <Stack
              sx={{
                width: {
                  xl: "90%",
                  lg: "90%",
                  md: "90%",
                  sm: "90%",
                  xs: "90%",
                },
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                // border: "2px solid green",
              }}
            >
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Stack
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: {
                      xl: "flex-end",
                      lg: "flex-end",
                      md: "flex-end",
                      sm: "flex-end",
                      xs: "center",
                    },
                    marginBottom: "16px",
                  }}
                >
                  Older
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    display: {
                      xl: "flex",
                      lg: "flex",
                      md: "flex",
                      sm: "flex",
                      xs: "none",
                    },
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginBottom: "16px",
                  }}
                >
                  Discription
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    display: {
                      xl: "flex",
                      lg: "flex",
                      md: "flex",
                      sm: "flex",
                      xs: "none",
                    },
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button variant="contained">Reading Time Button</Button>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              sx={{
                width: { xl: "10%", lg: "10%", md: "10%", sm: "10%" },
                // border: "2px solid green",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  height: { xl: "40px" },
                  width: { xl: "40px" },
                  borderRadius: "50%",
                  backgroundColor: "#365493",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  //   border: "2px solid red",
                  marginRight: "8px",
                }}
              >
                <FaGreaterThan size={20} style={{ color: "#FFFFFF" }} />
              </Stack>
            </Stack>{" "}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BlogSliderSection;
